var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.3 27.2",
    width: 27.382,
    height: 27.254,
    style: {
      enableBackground: "new 0 0 27.3 27.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:white;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.7,0.1C6.2,0.1,0.1,6.1,0.1,13.6s6.1,13.5,13.5,13.5s13.5-6.1,13.5-13.5S21.1,0.1,13.7,0.1z M7.5,5.8 c0.9,0,1.7,0.8,1.7,1.7S8.5,9.2,7.5,9.2S5.8,8.4,5.8,7.5S6.6,5.8,7.5,5.8z M9.3,21.4H5.8V10.7h3.5V21.4z M21.5,21.4H18 c0,0,0-4.4,0-6.9c-1.1-2.7-3.8,1-3.8,1v5.9h-3.5V10.7h3.5v2.1c0.4-0.6,1.7-2.1,3.8-2.1c0.2,0,0.4,0,0.6,0.1c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c1.5,0.4,2.6,1.7,2.6,3.4V21.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.b9fa04c4d3cbdd5fb7e07c841168df28.svg";
export { ForwardRef as ReactComponent };